<template>
	<div id="project-list">
		<v-subheader class="v-subheader">
			<v-layout>
				<v-icon class="text--secondary ma-1">device_hub</v-icon>
				<h1 class="text--secondary text-uppercase">{{ $t('projects.title') }}</h1>
			</v-layout>
		</v-subheader>
		<v-layout class="ma-5 align-center justify-center">
			<project-list-item class="cards" v-for="project in projects" :key="project.name"
							   @removeProject="removeProject"
							   :project="project">
			</project-list-item>
			<v-card elevation class="cards add-project" :to="`/project/new`">
				<v-icon large class="white--text">add</v-icon>
				<h3 class="white--text text-uppercase headline mb-0"> {{ $t('projects.add-project') }}</h3>
			</v-card>
		</v-layout>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProjectListItem from './project-list-item';

export default {
	name: 'ProjectsList',
	components: { ProjectListItem },
	computed: {
		...mapState({
			projects: state => state.project.projects,
		})
	},
	mounted() {
		this.getAllProjects();
	},
	methods: {
		...mapActions({
			getAllProjects: 'project/getAllProjects',
			deleteProject: 'project/deleteProject'
		}),
		removeProject(id) {
			this.deleteProject(id);
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

.v-subheader {
	min-height: 100px;
	padding: 20px;
	background-color: $light-grey;
}

#project-list {
	.cards {
		background-color: $background-grey !important;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 250px;
		height: 250px;
		margin: 10px;
		text-align: center;

		&:hover {
			background-color: $light-grey !important;
		}
	}

	.add-project {
		background-color: $bright-blue !important;

		&:hover {
			background-color: $dark-blue !important;
		}
	}

	.remove-button {
		position: absolute;
		top: 5px;
		right: 5px;
	}
}
</style>
